<template>
  <div class="header-top">
    <h2 class="hd-title">{{getSectionText}}</h2>
    <button type="button" @click="back()" class="btn-back">
      <span class="a11y-hidden">뒤로 가기</span>
      <span class="icon-back"><BackButton/></span>
    </button>
  </div>
</template>
<script>
import BackButton from '@/assets/svg/common/ic_gnb_back_w.svg'
export default {
  name: 'SearchHeaderTitle',
  components: {
    BackButton
  },
  props: {
    searchCategory: {
      type: String
    },
    mType: {
      type: String
    }
  },
  computed: {
    getSectionText () {
      let res = ''
      switch (this.searchCategory) {
        case 'program':
          res = '프로그램'
          break
        case 'vod':
          res = '에피소드'
          break
        case 'live':
          res = 'LIVE'
          break
        case 'movie':
          res = this.mType === 'svod' ? '영화' : '영화플러스'
          break
        case 'theme':
          res = '에디터Pick'
          break
        case 'faq':
          res = '고객지원'
          break
      }
      return res
    }
  },
  methods: {
    back () {
      this.$router.back()
    }
  }
}
</script>
